import {
  SEAT_SELECTION_TYPE,
  TravelReservation_Trip_Segment
} from '@com-delta-idp/mnx-trip-management-shared-ui';

import {
  AMENITIES,
  TRANSPORT_ATL_ARRIVAL,
  TRANSPORT_ATL_ORIGIN,
  TRANSPORT_HNL_ARRIVAL,
  TRANSPORT_HNL_ORIGIN,
  TRANSPORT_JAX_ARRIVAL,
  TRANSPORT_JAX_ORIGIN
} from './travel-reservation-segments-support.mocks';

export const TRAVEL_RESERVATION_SEGMENTS: TravelReservation_Trip_Segment[] = [
  {
    segmentId: 1,
    ordinal: 1,
    checkedIn: false,
    actionCode: 'HK',
    marketingSegment: {
      fareBasisCode: 'J0FN',
      operationalSuffix: 'DL',
      flightNum: '1234',
      carrier: [
        {
          code: 'DL',
          name: 'Delta Air Lines'
        }
      ]
    },
    operatingCarrier: [
      {
        code: 'DL',
        name: 'Delta Air Lines'
      }
    ],
    redEye: true,
    legs: [
      {
        legId: 1,
        ordinal: 1,
        carrier: [
          {
            code: 'DL',
            name: 'Thalys'
          }
        ],
        operationalSuffix: 'DL',
        flightNum: '9309',
        transportOrigin: TRANSPORT_JAX_ORIGIN,
        transportDestination: TRANSPORT_ATL_ARRIVAL,
        transportEquipment: {
          code: '75D',
          transportType: 'AIR',
          name: 'Boeing 757'
        },
        onAirDuration: 'PT1H20M',
        onGroundDuration: 'PT1H40M',
        status: 'ON_TIME',
        cabinClass: {
          code: 'SU',
          productCode: 'D1',
          amenities: AMENITIES
        },
        international: false,
        seatSelectionType: SEAT_SELECTION_TYPE.viewSeat,
        sameDayArrival: true,
        distanceMiles: 350
      }
    ],
    stops: '1',
    changeOfGauge: true,
    throughFlight: false,
    operationalStatus: {
      type: 'SCHEDULE_CHANGE',
      subType: 'SC Cleaned',
      flightNumChange: false
    },
    misconnect: false,
    standbyEligible: false,
    originStation: TRANSPORT_JAX_ORIGIN.station,
    destinationStation: TRANSPORT_ATL_ARRIVAL.station
  },
  {
    segmentId: 2,
    ordinal: 2,
    actionCode: 'HK',
    checkedIn: false,
    marketingSegment: {
      operationalSuffix: 'XX',
      flightNum: '427',
      fareBasisCode: 'J0FN',
      carrier: [
        {
          code: 'DL',
          name: 'Delta Air Lines'
        }
      ]
    },
    operatingCarrier: [
      {
        code: 'DL',
        name: 'Delta Air Lines'
      }
    ],
    redEye: true,
    legs: [
      {
        legId: 1,
        ordinal: 2,
        carrier: [
          {
            code: 'DL',
            name: 'Delta Air Lines'
          }
        ],
        operationalSuffix: 'DL',
        flightNum: '427',
        transportOrigin: TRANSPORT_ATL_ORIGIN,
        transportDestination: TRANSPORT_HNL_ARRIVAL,
        transportEquipment: {
          code: '35L',
          name: 'Airbus A350-900',
          transportType: 'AIR'
        },
        onAirDuration: 'PT9H55M',
        onGroundDuration: 'PT2H50M',
        status: 'ON_TIME',
        cabinClass: {
          code: 'SU',
          productCode: 'MAIN',
          amenities: AMENITIES
        },
        international: false,
        seatSelectionType: SEAT_SELECTION_TYPE.assignedAtGate,
        sameDayArrival: false,
        distanceMiles: 4490
      }
    ],
    stops: '1',
    changeOfGauge: true,
    throughFlight: false,
    operationalStatus: {
      type: 'SCHEDULE_CHANGE',
      subType: 'SC Cleaned',
      flightNumChange: false
    },
    misconnect: false,
    standbyEligible: false,
    originStation: TRANSPORT_ATL_ORIGIN.station,
    destinationStation: TRANSPORT_HNL_ARRIVAL.station
  }
];

export const SEGMENTS: TravelReservation_Trip_Segment[] = [
  {
    actionCode: 'HK',
    segmentId: 3,
    ordinal: 3,
    checkedIn: false,
    marketingSegment: {
      operationalSuffix: 'DL',
      flightNum: '394',
      fareBasisCode: 'J0FN',
      carrier: [
        {
          code: 'DL',
          name: 'Delta Air Lines'
        }
      ]
    },
    operatingCarrier: [
      {
        code: 'LA',
        name: 'LATAM Airlines'
      }
    ],
    legs: [
      {
        legId: 1,
        ordinal: 3,
        carrier: [
          {
            code: 'LA',
            name: 'LATAM Airlines'
          }
        ],
        operationalSuffix: 'RR',
        flightNum: '1294',
        transportOrigin: TRANSPORT_HNL_ORIGIN,
        transportDestination: TRANSPORT_ATL_ARRIVAL,
        transportEquipment: {
          code: '35L',
          transportType: 'AIR',
          name: 'Airbus A350-900'
        },
        onAirDuration: 'PT8H5M',
        onGroundDuration: 'PT1H20M',
        status: 'ON_TIME',
        cabinClass: {
          code: 'SU',
          productCode: 'D1',
          amenities: AMENITIES
        },
        international: false,
        seatSelectionType: SEAT_SELECTION_TYPE.assignedAtCheckin,
        sameDayArrival: true,
        distanceMiles: 4490
      }
    ],
    stops: '0',
    changeOfGauge: false,
    throughFlight: false,
    operationalStatus: {
      type: 'SCHEDULE_CHANGE',
      subType: 'SC_Cleaned',
      flightNumChange: false
    },
    standbyEligible: false,
    misconnect: false,
    redEye: true,
    originStation: TRANSPORT_HNL_ORIGIN.station,
    destinationStation: TRANSPORT_ATL_ARRIVAL.station
  },
  {
    actionCode: 'HK',
    segmentId: 4,
    ordinal: 4,
    checkedIn: false,
    marketingSegment: {
      operationalSuffix: 'DL',
      flightNum: '2854',
      fareBasisCode: 'J0FN',
      carrier: [
        {
          code: 'DL',
          name: 'Delta Air Lines'
        }
      ]
    },
    operatingCarrier: [
      {
        code: 'DL',
        name: 'Delta Air Lines'
      }
    ],
    legs: [
      {
        legId: 1,
        ordinal: 4,
        carrier: [
          {
            code: 'DL',
            name: 'Delta Air Lines'
          }
        ],
        operationalSuffix: 'DL',
        flightNum: '2854',
        transportOrigin: TRANSPORT_ATL_ORIGIN,
        transportDestination: TRANSPORT_JAX_ARRIVAL,
        transportEquipment: {
          code: '75D',
          transportType: 'AIR',
          name: 'Boeing 757'
        },
        onAirDuration: 'PT1H9M',
        onGroundDuration: 'PT1H10M',
        status: 'ON_TIME',
        cabinClass: {
          code: 'SU',
          productCode: 'MAIN',
          amenities: AMENITIES
        },
        international: false,
        seatSelectionType: SEAT_SELECTION_TYPE.viewSeat,
        sameDayArrival: true,
        distanceMiles: 350
      }
    ],
    stops: '0',
    changeOfGauge: false,
    throughFlight: false,
    misconnect: false,
    standbyEligible: false,
    redEye: true,
    originStation: TRANSPORT_ATL_ORIGIN.station,
    destinationStation: TRANSPORT_JAX_ARRIVAL.station
  }
];
